import { computed, effect, inject, Injectable } from '@angular/core';
import { AuthenticationService } from '../auth/auth_service';
import { entities } from '../client/client';
import { ClientService } from '../client/client.service';

@Injectable({
  providedIn: 'root',
})
export class CheckAccessDataService {
  private auth = inject(AuthenticationService);
  private client = inject(ClientService);

  private readonly userRolesKey = 'userRoles';

  readonly roles = computed(() => {
    const jwt = this.auth.jwt();
    if (jwt) {
      return jwt.roles ?? [];
    }
    return this.loadRolesFromStorage();
  });

  constructor() {
    effect(() => {
      const jwt = this.auth.jwt();
      if (jwt) {
        localStorage.setItem(this.userRolesKey, JSON.stringify(jwt.roles ?? []));
      } else if (!this.auth.loggedIn()) {
        localStorage.removeItem(this.userRolesKey);
      }
    });
  }

  async GetStaff(): Promise<void> {
    const client = await this.client.getRequestClient();
    await client.accountinternal.GetMyStaff();
    await this.auth.refreshJwt();
  }

  async CreateStaff(dto: entities.CreateStaffRequest): Promise<void> {
    const client = await this.client.getRequestClient();
    await client.accountinternal.CreateMyStaff(dto);
    await this.auth.refreshJwt();
  }

  getRolesData(): string[] {
    return this.roles();
  }

  hasRole(role: string): boolean {
    return this.roles().includes(role);
  }

  private loadRolesFromStorage(): string[] {
    const userAuthDataString = localStorage.getItem(this.userRolesKey);
    return userAuthDataString ? JSON.parse(userAuthDataString) : [];
  }
}
